import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Submenu',
  props: {
    hasTable: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(NavBarMenu, null, {
        default: _withCtx(() => [_createVNode(NavBarMenuItem, {
          to: {
            name: 'divisions.matches',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.ScoreboardOutlined,
          label: _ctx.$t('matches')
        }, null, 8, ["to", "icon", "label"]), __props.hasTable ? (_openBlock(), _createBlock(NavBarMenuItem, {
          key: 0,
          to: {
            name: 'divisions.table',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.FormatListNumberedOutlined,
          label: _ctx.$t('table')
        }, null, 8, ["to", "icon", "label"])) : _createCommentVNode("", true), _createVNode(NavBarMenuItem, {
          to: {
            name: 'divisions.player-competition-logs',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.FormatListNumberedOutlined,
          label: _ctx.$t('player_stats')
        }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
          to: {
            name: 'competitions.index'
          },
          label: _ctx.$t('competitions'),
          icon: _ctx.IconEnum.World
        }, null, 8, ["to", "label", "icon"])]),
        _: 1
      });
    };
  }
});